export function heavyObject<T extends Record<string, any>>(object: T) {
  // make sure to remove any falsy value
  if (!object) return {};

  return Object.fromEntries(
    Object.entries(object).filter(([_, value]) => !!value),
  );
}
